import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from "../css/gis.module.css"

export const PopupViewSgnInf = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)
    
    // 오버플로우 상태를 추적할 ref와 state
    const nmRef = React.useRef(null);
    const idRef = React.useRef(null);
    const [nmOverflow, setNmOverflow] = React.useState(false);
    const [idOverflow, setIdOverflow] = React.useState(false);

    React.useEffect(() => {
        setTransitionIn(false);
        const key = setTimeout(() => {
          setTransitionIn(true);

    // DOM이 확실히 렌더링된 후 측정
    if (nmRef.current) {
        const nmEl = nmRef.current;
        const overflow = nmEl.scrollWidth > nmEl.clientWidth;
        console.log("nmRef", { scrollWidth: nmEl.scrollWidth, clientWidth: nmEl.clientWidth, overflow });
        setNmOverflow(overflow);
      }
      if (idRef.current) {
        const idEl = idRef.current;
        const overflow = idEl.scrollWidth > idEl.clientWidth;
        console.log("idRef", { scrollWidth: idEl.scrollWidth, clientWidth: idEl.clientWidth, overflow });
        setIdOverflow(overflow);
      }
    }, 400); // Zoom in 이후에 측정되도록 타이밍 확보
  
    return () => clearTimeout(key);
  }, [item.id, item.nm]);


    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_sgninf} gisPopup flx flx_col gap6`} style={{width:'440px'}}>
                {/* <div className='popTit'>신호정보개방 <span className='id'>{item.nm}</span></div> */}
                <div className='popConts flx a_center'>
                    <div className='popTit'>신호정보개방</div>
                    <div className='flow_wrap' ref={idRef}>
                        <span className={`id flow_txt ${idOverflow ? "animate-delay": ""}`}>{item.nm}</span>
                    </div>
                </div>
                <div className='flx a_center w_100'>
                    <div className='popTit'>종류</div>
                    <div className='popTit'>{item.tp}</div>
                </div>
                <div  className='flx a_center w_100'>
                    <div className='popTit'>넘버</div>
                    <div className='popTit'>{item.sgnlNo}</div>
                </div>
            </div>
        </Zoom>
    )
}